import { Directory, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { isPlatform } from '@ionic/vue';
import { Monitoring } from './monitoring';
import { convertBlobToBase64 } from './photo-storage';

// TODO: consolidate with other convertBlobToBase64 function in useDownloadHelper

const isMobilePlatform = (): boolean => {
    return isPlatform("ios") || isPlatform("ipad") || isPlatform("android") || isPlatform("iphone") || isPlatform("capacitor");
};

export const downloadFileCapacitor = async (data: any, filename: string, mime: string) => {
    try {
        const blob = new Blob([data], {
            type: mime || "application/octet-stream",
        });

        const base64Data = await convertBlobToBase64(blob);

        await Filesystem.writeFile({
            path: filename,
            data: base64Data,
            directory: Directory.Cache,
        });

        const uriResult = await Filesystem.getUri({
            directory: Directory.Cache,
            path: filename,
        });

        await Share.share({
            title: filename,
            url: uriResult.uri,
        });

    } catch (error) {
        throw Monitoring.toBubbleUp("Failed to download and share Excel file", error);
    }
};

export const downloadFileWeb = (data: any, filename: string, mime: string) => {
    const url = window.URL.createObjectURL(new Blob([data], { type: mime || "application/octet-stream" }));
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
};

export const downloadFile = async (data: any, filename: string, mime: string) => {
    if (isMobilePlatform()) {
        await downloadFileCapacitor(data, filename, mime);
    } else {
        downloadFileWeb(data, filename, mime);
    }
};